(() => {
  if (window.__bpcProductEnhancementsLoaded) return;
  window.__bpcProductEnhancementsLoaded = true;

  const enhanceProductOptions = (root = document) => {
    root.querySelectorAll('product-info').forEach((productInfo) => {
      const quantity = productInfo.querySelector(':scope > .product-form__quantity');
      if (!quantity || quantity.closest('.bpc-product-options-row')) return;
      quantity.classList.add('bpc-quantity-compact');
      const variantPicker = productInfo.querySelector(':scope > variant-selects, :scope > variant-radios');
      if (!variantPicker || variantPicker.matches('variant-radios')) return;
      const optionInputs = variantPicker.querySelectorAll('.product-form__input');
      const dropdowns = variantPicker.querySelectorAll('select');
      if (optionInputs.length !== 1 || dropdowns.length !== 1) return;
      const row = document.createElement('div');
      row.className = 'bpc-product-options-row';
      row.setAttribute('data-bpc-product-options-row', '');
      variantPicker.before(row);
      row.append(variantPicker, quantity);
    });
  };

  const enhanceDescriptions = (root = document) => {
    root.querySelectorAll('.product__description:not([data-bpc-description-ready])').forEach((description) => {
      description.dataset.bpcDescriptionReady = 'true';
      description.classList.add('bpc-description-enhanced');
      const collapseHeight = window.matchMedia('(max-width: 749px)').matches ? 250 : 340;
      if (description.scrollHeight <= collapseHeight + 40) return;
      const button = document.createElement('button');
      const descriptionId = description.id || `BpcDescription-${Math.random().toString(36).slice(2, 9)}`;
      description.id = descriptionId;
      description.classList.add('bpc-description-collapsed');
      button.type = 'button';
      button.className = 'bpc-description-toggle';
      button.textContent = 'Read more';
      button.setAttribute('aria-controls', descriptionId);
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => {
        const expanded = description.classList.toggle('bpc-description-expanded');
        description.classList.toggle('bpc-description-collapsed', !expanded);
        button.textContent = expanded ? 'Show less' : 'Read more';
        button.setAttribute('aria-expanded', String(expanded));
        if (!expanded) description.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      description.insertAdjacentElement('afterend', button);
    });
  };

  const render = (root = document) => { enhanceProductOptions(root); enhanceDescriptions(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => render(), { once: true });
  else render();
  document.addEventListener('shopify:section:load', (event) => render(event.target));
})();
